<template>
  <div>
    <a href="#" @click.prevent="onClick" class="h-16 text-red-500 bg-gray-200 px-4 mt-4 flex justify-between items-center">
      <div class="text-lg font-semibold">{{ heading }}</div>
      <font-awesome-icon :icon="['far', isOpen ? 'chevron-up' : 'chevron-down']" />
    </a>
    <div class="bg-gray-200 pr-4 pb-4 pl-4" v-if="isOpen">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'collapse',
  props: {
    heading: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isOpen: false,
    }
  },
methods: {
  onClick () {
    this.isOpen = !this.isOpen
    this.$emit(this.isOpen ? 'open' : 'close')
  }
}
}
</script>